import { tv } from 'tailwind-variants'

export const tooltipContentVariants = tv({
  base: [
    'z-[9999]',
    'p-2',
    'text-white text-sm text-left',
    'rounded-xl bg-charcoal shadow-white-inset-md',
    'animate-in fade-in-0 zoom-in-95',
    'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
    'data-[side=bottom]:slide-in-from-top-2',
    'data-[side=left]:slide-in-from-right-2',
    'data-[side=right]:slide-in-from-left-2',
    'data-[side=top]:slide-in-from-bottom-2'
  ],
  variants: {
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    }
  },
  defaultVariants: {
    position: 'top'
  }
})

export const tooltipArrowVariants = tv({
  base: 'fill-charcoal',
  variants: {
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    }
  },
  defaultVariants: {
    position: 'top'
  }
})
